import { render } from "./apply-warehouse-pinter.vue?vue&type=template&id=27527153&scoped=true&ts=true"
import script from "./apply-warehouse-pinter.vue?vue&type=script&lang=ts"
export * from "./apply-warehouse-pinter.vue?vue&type=script&lang=ts"

import "./apply-warehouse-pinter.vue?vue&type=style&index=0&id=27527153&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27527153"]])

export default __exports__